var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-builder-layout-placeholder-sessions" },
    _vm._l(_vm.PLACEHOLDER_SAMPLES, function (i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "layout-builder-layout-placeholder-sessions-row",
        },
        [
          _c("div", {
            staticClass:
              "layout-builder-layout-placeholder-sessions-row-avatar",
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "layout-builder-layout-placeholder-sessions-row-line",
          }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }